import { User, Calendar, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WordPopLogo } from "@/components/ui/WordPopLogo";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface CompactHeaderProps {
  puzzleNumber: number;
  onUserClick: () => void;
  onSettingsClick: () => void;
  onArchiveClick: () => void;
  isAuthenticated?: boolean;
  userInitial?: string;
}

export function CompactHeader({ 
  puzzleNumber,
  onUserClick,
  onSettingsClick,
  onArchiveClick,
  isAuthenticated,
  userInitial,
}: CompactHeaderProps) {
  return (
    <header className="sticky top-0 z-20 w-full">
      <div className="w-full max-w-[360px] mx-auto px-2 py-2 flex items-center">
        {/* Left: Just puzzle number */}
        <div className="flex-shrink-0 w-12">
          <p className="text-sm font-medium text-foreground">
            #{puzzleNumber}
          </p>
        </div>

        {/* Center: WordPop Logo - flexbox centered */}
        <div className="flex-1 flex justify-center">
          <WordPopLogo linkTo="/" size="sm" />
        </div>

        {/* Right: Settings, User, Archive */}
        <div className="flex items-center gap-0.5 flex-shrink-0">
          <Button
            variant="ghost"
            size="icon"
            onClick={onSettingsClick}
            className="h-8 w-8 rounded-full"
            aria-label="Settings"
          >
            <Settings className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onUserClick}
            className="h-8 w-8 rounded-full"
            aria-label="Profile"
          >
            {isAuthenticated && userInitial ? (
              <Avatar className="h-6 w-6">
                <AvatarFallback className="bg-primary text-primary-foreground text-xs font-semibold">
                  {userInitial}
                </AvatarFallback>
              </Avatar>
            ) : (
              <User className="h-4 w-4" />
            )}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onArchiveClick}
            className="h-8 w-8 rounded-full"
            aria-label="View archive"
          >
            <Calendar className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
